import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalAddResourceOld from "root/Modals/AddResource/ModalAddResource";

const useModalAddResource = ( onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { openState: false, mode: 'none', resource_id: null })  ;

    const onClickActivate = ( newMode, resource_id ) =>
    {
        switch ( newMode )
        {
            case 'view':
                setDialog ({ openState: true, resource_id: resource_id,  mode: 'view'});
                break ;
            case 'delete':
                setDialog ({ openState: true, resource_id:  resource_id, mode: 'delete'});
                break ;
            case 'create':
                setDialog ({ openState: true, resource_id:  resource_id, mode: 'create'});
                break ;
            case 'edit':
                setDialog ({ openState: true, resource_id:  resource_id,  mode: 'edit'});
                break ;
        }
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, resource_id: null, key: null, mode: 'none'});
    };

    const onSaveComplete = ( key ) =>
    {
        // Close the dialog
        setDialog ({ openState: false, resource_id: null, mode: 'none'});
        // Tell the parent we're done
        onSaveCompleted( key ) ;
    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && < ModalAddResourceOld resource_id={dialog.resource_id} onSaveCompleted={onSaveComplete} onClose={onCloseModal} mode={dialog.mode} /> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalAddResource ;
